import Image from "next/image"

import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { Text } from "components/shared/text"

import { AbilityGrade } from "../ability-grade"
import styles from "./ability-avatar.module.scss"

export const fiveItemsArr = new Array(5).fill(null)

export type AbilityAvatarProps = {
  level: number
  count: number
  imageUrl: string
  showEnergy?: boolean
}

export function AbilityAvatar({ level, count, imageUrl, showEnergy }: AbilityAvatarProps) {
  const { isMobile } = useTailwindBreakpoints()
  return (
    <Box className={`items-center lg:items-start flex-shrink-0 ${showEnergy ? "mb-8" : ""}`}>
      <Box className="relative">
        <Box className="w-[44px] h-[44px] lg:w-[96px] lg:h-[96px]">
          <Image src={imageUrl} alt="ability image" width={isMobile ? 44 : 96} height={isMobile ? 44 : 96} />
        </Box>
        {!isMobile && (
          <Box
            className={`w-[32px] h-[32px] rounded-lg ${styles["ability-avatar-gradient"]} absolute -top-[4px] -right-[4px] justify-center items-center`}
          >
            <Text weight="bold" size="sm">
              {count}
            </Text>
          </Box>
        )}
      </Box>
      {isMobile ? (
        <Box>
          <Text className="text-[#9188E2]" size="sm">
            Level {level}
          </Text>
        </Box>
      ) : (
        <AbilityGrade level={level} />
      )}
    </Box>
  )
}
